import React from 'react'
import PropTypes from 'prop-types'
import courtType from '../../../../types/courtType'
import mutationType from '../../../../types/mutationType'
import teamType from '../../../../types/teamType'
import eventVariantType from '../../../../types/events/eventVariantType'
import calendarDateClickType from '../../../../types/calendarDateClickType'
import eventType from '../../../../types/events/eventType'
import eventRawType from '../../../../types/events/eventRawType'
import useGetLocalStorage from '../../../../hooks/useGetLocalStorage'
import localStorageIds from '../../../../utils/constants/localStorageIds'
import ORGANISATION_SPORTS from '../../../../utils/constants/organisationSports'
import BasketGameEventForm from './BasketGameEventForm'
import VolleyGameEventForm from './VolleyGameEventForm'

const GAME_FORM_BY_SPORT = {
  [ORGANISATION_SPORTS.BASKETBALL]: BasketGameEventForm,
  [ORGANISATION_SPORTS.VOLLEYBALL]: VolleyGameEventForm,
}

const GameEventForm = (props) => {
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.SELECTED_ORG]: selectedOrg } = localStorageValue || {}
  const { sport } = selectedOrg || {}

  const FormComponent = GAME_FORM_BY_SPORT[sport] ?? BasketGameEventForm

  return <FormComponent {...props} />
}

GameEventForm.propTypes = {
  clickedEventId: PropTypes.string,
  createEvent: mutationType,
  updateEvent: mutationType,
  event: eventType,
  selectedEventType: eventVariantType,
  setFormDirty: PropTypes.func,
  currentTeam: teamType,
  teams: PropTypes.arrayOf(teamType),
  dateClick: calendarDateClickType,
  eventsRaw: PropTypes.arrayOf(eventRawType),
  setEvents: PropTypes.func,
  courts: PropTypes.arrayOf(courtType),
}

export default GameEventForm
